// Daily Totals table — extracted verbatim from StatisticsPage.tsx.
import React from 'react';
import { DailyRow } from './shared';

export default function DailyTable({ daily, isManager }: { daily: DailyRow[]; isManager: boolean }) {
  return (
    <div className="bg-[#1a1d27] rounded-xl border border-gray-800 mb-5">
      <div className="px-4 py-3 border-b border-gray-800">
        <h2 className="text-sm font-semibold text-white">Daily Totals</h2>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-gray-500 text-xs border-b border-gray-800">
              <th className="px-4 py-2 text-left font-medium">Date</th>
              {isManager && <th className="px-4 py-2 text-left font-medium">Person</th>}
              <th className="px-4 py-2 text-right font-medium">P&P</th>
              <th className="px-4 py-2 text-right font-medium">Processed</th>
              <th className="px-4 py-2 text-right font-medium">Problems</th>
            </tr>
          </thead>
          <tbody>
            {daily.length === 0 ? (
              <tr>
                <td colSpan={isManager ? 5 : 4} className="px-4 py-10 text-center text-gray-600 text-sm">
                  No data in this period
                </td>
              </tr>
            ) : daily.map((d, i) => (
              <tr key={i} className="border-b border-gray-800/50 hover:bg-gray-800/20 transition-colors">
                <td className="px-4 py-2.5 text-gray-300 whitespace-nowrap">{d.date}</td>
                {isManager && <td className="px-4 py-2.5 text-gray-200">{d.display_name}</td>}
                <td className="px-4 py-2.5 text-right font-semibold text-gray-100">{d.pp_count || <span className="text-gray-700">—</span>}</td>
                <td className="px-4 py-2.5 text-right text-gray-400">{d.processed_count || <span className="text-gray-700">—</span>}</td>
                <td className="px-4 py-2.5 text-right">
                  {d.problem_count > 0
                    ? <span className="text-red-400 font-medium">{d.problem_count}</span>
                    : <span className="text-gray-700">—</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
